import { Component, Input } from "@angular/core";

@Component({
  selector: "modal-footer",
  templateUrl: "./modal-footer.component.html",
  host: {
    class: "tw-flex tw-justify-end",
  },
})
export class ModalFooterComponent {
  @Input() isFullWidth: boolean;
}
